import { useEffect, useState } from 'react'
import { RecaptchaVerifier } from 'firebase/auth'
import { useAuth } from 'reactfire'

export function useRecaptchaVerifier() {
  // Verifiers are single-use: each setRecaptchaUsed call bumps the generation
  // so the effect tears down the spent verifier and creates a fresh one. Keep
  // this a counter, not a boolean flag: a flag needs resetting, which re-runs
  // the effect and destroys the replacement verifier it just created.
  const [generation, setGeneration] = useState(0)
  const [recaptchaVerifier, setRecaptchaVerifier] = useState(null)
  const [recaptchaLoading, setRecaptchaLoading] = useState(true)
  const auth = useAuth()

  useEffect(() => {
    setRecaptchaLoading(true)

    const containerId = `recaptcha-container-${Math.random().toString(36).substring(7)}`
    const container = document.createElement('div')
    container.id = containerId
    document.body.appendChild(container)

    const verifier = new RecaptchaVerifier(auth, containerId, {
      size: 'invisible',
    })

    setRecaptchaVerifier(verifier)
    setRecaptchaLoading(false)

    return () => {
      setRecaptchaVerifier(null)
      verifier.clear()
      container.remove()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generation])

  const setRecaptchaUsed = () => setGeneration((current) => current + 1)

  return { recaptchaVerifier, recaptchaLoading, setRecaptchaUsed }
}
